import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    cards: {
        id: 'cards.page.header',
        defaultMessage: 'Cards',
    },
    card: {
        id: 'cards.page.header_mobile',
        defaultMessage: 'Card {numbers}',
    },
    getNewCard: {
        id: 'cards.page.get_new_card',
        defaultMessage: 'Get new card',
    },
})
